import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Link } from 'react-router'
import InspectionItem from '../InspectionItem'
import { renderFullDate } from '../../../../utils/time'
import Extent from '../../../../shared/components/Extent'
// import Price from '../../../PriceCalculation/Price'
import { hasAccess, hasSubscriptionPermission } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'
import { formatCurrency } from '../../../../utils/currency'
import { makeOrderAssessmentIcon } from '../../../../utils/order'
import {
  FILE_STORAGE_API, AssessmentSystemType
} from '../../../../constants'

// Elements
import Button from '../../../../shared/elements/button'
import DropDown from '../../../../shared/elements/dropDown'
import Inline from '../../../../shared/elements/inline'
import Grid from '../../../../shared/elements/grid'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Icon from '../../../../shared/elements/icon'
import Expand from '../../../../shared/elements/expand'
import Label from '../../../../shared/elements/label'
import Actions from '../../../../shared/elements/actions'
import UserInfo from '../../../../shared/components/UserInfo'

const DEPARTMENTTYPE = {
  Paint: 0,
  Body: 1
}
const REPORTTYPE = {
  Unknown: 0,
  Forsi: 1,
  ForsiManual: 2, // RP
  DBS: 3
}

class Assessment extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
      showExtent: false
    }
    this.renderContent = this.renderContent.bind(this)
    this.renderAdditionalSales = this.renderAdditionalSales.bind(this)
    this.renderPriceCalculation = this.renderPriceCalculation.bind(this)
    // this.renderForsiReport = this.renderForsiReport.bind(this)
    // this.renderBodyShopForsiReport = this.renderBodyShopForsiReport.bind(this)
    // this.renderBodyShopPriceDiff = this.renderBodyShopPriceDiff.bind(this)
    this.GetIcon = this.GetIcon.bind(this)
    this.ToAfterEvaluation = this.ToAfterEvaluation.bind(this)
  }

  componentDidMount () {
  }

  formatSectionType (sectionType) {
    switch (sectionType) {
      case 1:
        return DEPARTMENTTYPE.Paint
      case 2:
        return DEPARTMENTTYPE.Body
      default:
        break
    }
  }

  // renderBodyShopPriceDiff () {
  //   let hasForsiReport = this.props.order.Report !== null && this.props.order.Report.ReportType === REPORTTYPE.Forsi
  //   // if (this.props.order.BodyShopForsiOrderExtent === null) return null
  //   if (this.props.order.OrderDepartment === DEPARTMENTTYPE.Body && !hasForsiReport) return null
  //   // ???
  //   if (this.props.order.BodyShopForsiOrderExtent.CheckReportDiff !== true) return null
  //   return (
  //     <div className='forsi_diff'>{translation('749')}</div>
  //   )
  // }

  renderPriceCalculation (isBodyShop = false, editDenied = false) {
    let { OrderType } = this.props.order
    // console.log('Order', this.props.order)

    let orderExtent = this.props.order.OrderExtent
    // if (orderExtent === null) return null
    let extentLines = []
    if (orderExtent !== null && orderExtent !== '') {
      extentLines = this.props.order.OrderExtent.split('<br />')
    }

    const renderLine = (val, key) => {
      return (
        <p key={'extentLine_' + key}>{val}</p>
      )
    }

    // Other
    // console.log('OrderType', OrderType)
    if (OrderType === 4) {
      // let extentImage = <div><img src='/images/svgs/ordrer/Other-black.svg' className='subtitleIMG' /></div>

      return (
        <Expand title={translation('73')}>
          <Actions>
            <div className='icon hint--top' aria-label={translation('2706')}>
              <img src='/images/icons/edit_16.png' />
            </div>
          </Actions>

          <div className='extent_other' onClick={hasSubscriptionPermission(this.props.auth, 0, 2) && this.openOtherPopup}>
            {/* <div className='subtitle'>{extentImage}{translation('73')}
              <div className='icon hint--top' aria-label={translation('2706')}><img src='/images/icons/edit_16.png' /></div>
        </div> */}
            <Inline fillChildNum={[0]} block>
              <Label>{translation('1206')}</Label>
              {this.props.order.OtherTitle || ''}
            </Inline>
            <Inline fillChildNum={[0]} block>
              <Label>{translation('1021')}</Label>
              {this.props.order.OtherDescription || ''}
            </Inline>
            <Inline fillChildNum={[0]} block>
              <Label>{translation('641')}</Label>
              <span>{formatCurrency(this.props.order.Price || 0)}</span>
            </Inline>
            <Inline fillChildNum={[0]} block>
              <Label>{translation('13339')}</Label>
              <span>{formatCurrency(this.props.order.Environment || 0)}</span>
            </Inline>
          </div>
        </Expand>
      )
    }
    // let noPrices = false
    // if (OrderType === 1) {
    //   noPrices = true
    // }

    // Price calculation
    // TODO: Ikke vis other price på insurance og other
    let isReferredIn = this.props.order.IsReferredIn
    if (isReferredIn) {
      if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
        isReferredIn = false
      }
    }

    let extentLink = isBodyShop ? '/bodyextent' : '/1'

    // console.log(this.props.order)
    // let hasExtent = this.props.order.HasExtent
    let isAssessmentOk = true // isBodyShop ? this.props.order.IsBodyShopAssessmentOk : this.props.order.IsAssessmentOk
    // if (isBodyShop) hasExtent = true || this.props.order.HasExtentBodyShop
    let pric = <Extent
      order={this.props.order}
      department={isBodyShop ? 1 : 0}
      showAgreementPrice={false}
      extents={[{
        type: 'base',
        editable: false
      }]}
    />
    let hasForsiPaint = this.props.order.Report && this.props.order.Report.Paint && this.props.order.Report.ReportType === REPORTTYPE.Forsi
    let hasForsiBody = this.props.order.Report && this.props.order.Report.Body && this.props.order.Report.ReportType === REPORTTYPE.Forsi
    return (
      <div className='extent_box clearfix'>
        {!hasAccess([6], this.props.auth.user.UserType) && isBodyShop === true && (
          <Link to={!hasForsiBody && this.props.order.OrderType !== 1 && !isAssessmentOk && !isReferredIn && (hasSubscriptionPermission(this.props.auth, 0, 2)) ? '/pricecalculation/' + this.props.order.Id + extentLink : ''}>
            {pric}
            {extentLines !== null && extentLines.length > 0 && (
              <div className='OldOrderExtent'>
                {extentLines.map(renderLine)}
                <br />
              </div>
            )}
          </Link>
        )}

        {!hasAccess([6], this.props.auth.user.UserType) && isBodyShop === false && (
          <Link to={!hasForsiPaint && !isAssessmentOk && !isReferredIn && (hasSubscriptionPermission(this.props.auth, 0, 2)) ? '/pricecalculation/' + this.props.order.Id + extentLink : ''}>
            {this.props.order.HasAwaiting && (
              <div className='forsi_diff'>{translation('2729')}</div>
            )}
            {pric}
            {extentLines !== null && extentLines.length > 0 && (
              <div className='OldOrderExtent'>
                {extentLines.map(renderLine)}
                <br />
              </div>
            )}
          </Link>
        )}

        {hasAccess([6], this.props.auth.user.UserType) && (
          <div>
            {this.props.order.HasAwaiting && (
              <div className='forsi_diff'>{translation('2729')}</div>
            )}
            {pric}
          </div>
        )}
      </div>
    )
  }

  renderAdditionalSales (isBodyShop = false) {
    if (this.props.order.OrderType === 4) return null
    let isReferredIn = this.props.order.IsReferredIn
    let isAssessmentOk = true
    if (isReferredIn) {
      if (this.props.order.OrderConnection !== undefined && this.props.order.OrderConnection !== null && this.props.order.OrderConnection.IsApproved) {
        isReferredIn = false
      }
    }
    let addonPriceComment = this.props.order.AddonPriceComment !== null ? this.props.order.AddonPriceComment : ''
    if (this.props.order.IsDummy) {
      addonPriceComment = 'Pris'
    }
    // let showPrices = hasAccess([6], this.props.auth.user.UserType) || this.props.order.ShowPrices
    let addedPrice = <Extent
      order={this.props.order}
      department={isBodyShop ? 1 : 0}
      showAgreementPrice={false}
      extents={[{
        type: 'addon',
        editable: false,
        noTitle: true
      }]}
    />

    let extentLink = isBodyShop ? '/bodyaddon' : '/2'
    let hasExtentAddon = this.props.order.HasExtentAddon // HasExtentBodyShopAddon
    if (isBodyShop) hasExtentAddon = this.props.order.HasExtentBodyShopAddon
    return (
      <div className='additional_sales_box'>
        {!hasAccess([6], this.props.auth.user.UserType) && (
          <div>
            <Link to={!isAssessmentOk && !isReferredIn && hasSubscriptionPermission(this.props.auth, 0, 2) ? '/pricecalculation/' + this.props.order.Id + extentLink : ''}>
              {hasExtentAddon && (
                <Expand title={translation('1396')}>
                  {this.props.order.HasAwaitingAddon && (
                    <div className='forsi_diff'>{translation('17840')}</div>
                  )}
                  {addedPrice}
                  {this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && (<span>{addonPriceComment}: {formatCurrency(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)}</span>)}
                </Expand>
              )}
            </Link>
          </div>
        )}
        {hasAccess([6], this.props.auth.user.UserType) && (
          <div>
            {this.props.order.HasExtentAddon && (
              <Expand title={translation('1396')}>
                {this.props.order.HasAwaitingAddon && (
                  <div className='forsi_diff'>{translation('17840')}</div>
                )}
                {addedPrice}
                {this.props.order.OrderExtent !== null && this.props.order.AddonPrice > 0 && (<span>{addonPriceComment}: {formatCurrency(isBodyShop ? this.props.order.BodyShopAddonPrice : this.props.order.AddonPrice || 0)}</span>)}
              </Expand>
            )}
          </div>
        )}
      </div>
    )
  }

  GetIcon (assessmentItem, complete) {
    let icon = makeOrderAssessmentIcon(assessmentItem.Name, complete)
    return (
      <div className='imgDiv hint--right' aria-label={translation(assessmentItem.Name)}>
        <Icon icon={icon} />
      </div>
    )
  }

  ToAfterEvaluation () {
    const isWP = hasAccess([6], this.props.auth.user.UserType)
    const isAfterEval = this.props.order.OrderType === 1
    let isDisabled = this.props.AfterEvaluation.Checked || (isWP && !isAfterEval)
    let disabledNoPermission = false
    if (isAfterEval && !hasSubscriptionPermission(this.props.auth, 30)) {
      isDisabled = true
      disabledNoPermission = true
    }

    const ConditionalLink = props => {
      const onClick = () => {
        if (disabledNoPermission === true) return null
        let msg = '15025'
        if (isWP && !isAfterEval) {
          msg = '15038'
        }
        window.toastr.error(translation(msg), translation('216'))
      }

      if (!isDisabled) {
        if (isAfterEval) {
          return (
            <Link to={'/pricecalculation/' + this.props.order.Id + '/4'} className='left' disabled={isDisabled}>
              {props.children}
            </Link>
          )
        } else {
          return (
            <Link to={'/pricecalculation/' + this.props.order.Id + (!this.props.isBodyshop ? '/1' : '/bodyextent')} className='left' disabled={isDisabled}>
              {props.children}
            </Link>
          )
        }
      } else {
        return (
          <a className='left' onClick={onClick}>
            {props.children}
          </a>
        )
      }
    }

    let title = '13565'
    if (isAfterEval) {
      title = '14714'
    }

    if (!hasSubscriptionPermission(this.props.auth, 30)) return null
    return (
      <ConditionalLink>
        <Button style='secondary' labelText={translation(title)} disabled={isDisabled} />
        {/* <img src='\images\svgs\taksering\after-charge-white.svg' /> */}
      </ConditionalLink>
    )
  }

  renderContent () {
    // Do not show button for Complaints
    if (this.props.order.OrderType === 5) return null
    let hasForsiReport = this.props.order.Report !== null && this.props.order.Report.ReportType === REPORTTYPE.Forsi
    let assessmentItems = this.props.assessmentItems
    const renderAssessmentItem = (assessmentItem, index) => {
      let className = 'assessmentItem'

      if (index < assessmentItems.AssessmentItemDetails.length - 1) className += ' assessment_item_bottomborder'
      // {
      let assessmentItemLabel = (
        <Inline>
          {translation(assessmentItem.Name)}
          {this.props.isBodyshop && renderDownloadLink()}
        </Inline>
      )
      return (
        <Inline key={'assesmentItem_' + index} fillChildNum={[1]} block>
          {this.GetIcon(assessmentItem, assessmentItem.Completed)}
          <LabelWrapper labelText={assessmentItemLabel} className={className}>
            <Grid cols={[ 'max-content', 'max-content', 1, '24px' ]}>
              <div className='assessment-date'>{renderFullDate(assessmentItem.Date, false, undefined)}</div>
              <div className='assessment-time'>{renderFullDate(assessmentItem.Date, true, true)}</div>
              <div className='assessment-creator'><UserInfo user={assessmentItem.CreatedByUserInfo} /></div>
              {assessmentItem.OnWorkcard && !this.props.isBodyshop && (
                <Icon icon={makeOrderAssessmentIcon(159)} />
              )}
            </Grid>
          </LabelWrapper>
        </Inline>
      )
    }
    const renderDownloadLink = () => {
      if (!hasForsiReport || this.props.auth.departmentType === DEPARTMENTTYPE.Paint) return null
      let report = this.props.order.Report
      let attachment = report.Attachments.find(file => this.formatSectionType(file.SectionType) === this.props.auth.departmentType)
      if (this.props.auth.departmentType === DEPARTMENTTYPE.Body && hasForsiReport && attachment && attachment.OrderFileId) {
        if (attachment.FileName === null) return null
        let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)

        return (
          <a href={newFileUrl} title={attachment.FileName} target='_blank'><img src='/images/svgs/download.svg' alt='' className='downloadIcon' /></a>
        )
      }
    }
    const selectChange = (e) => {
      this.props.onChange(e)
    }
    const renderSelect = () => {
      return (
        <DropDown labelText={translation('13052') + ':'} onChange={selectChange} value={this.props.AfterEvaluation.AssessmentSelection}>
          <option value={0}>{translation('15000')}</option>
          {this.props.order.OrderType === 1 && <option value={1}>{translation('15001')}</option>}
          {this.props.order.OrderType === 2 && this.props.auth.departmentType !== 1 && <option value={3}>{translation('15281')}</option>}
          <option value={2}>{translation('15002')}</option>
        </DropDown>
      )
    }

    const renderExtent = (type) => {
      let renderPriceCalculation = this.renderPriceCalculation(this.props.isBodyshop)
      let renderAdditionalSales = this.renderAdditionalSales(this.props.isBodyshop)

      let extentClass = 'extent'
      if (this.state.showExtent) {
        extentClass += ' open'
      }
      return (
        <div className={extentClass}>
          <div>{type === 'normal' && renderPriceCalculation}</div>
          <div>{renderAdditionalSales}</div>
        </div>
      )
    }
    let assessmentClassName = 'assessmentItems'
    if (!(assessmentItems && assessmentItems.AnyOnWorkcard && assessmentItems.AssessmentItemDetails.length > 0)) assessmentClassName += '2'
    return (
      <div>
        {renderSelect()}
        <div className={assessmentClassName}>
          {assessmentItems && assessmentItems.AssessmentItemDetails.map(renderAssessmentItem)}
        </div>
        {renderExtent('normal')}
        {!this.props.isBodyshop && this.ToAfterEvaluation()}
        {hasAccess([3, 5, 6, 7], this.props.auth.user.UserType) && hasSubscriptionPermission(this.props.auth, 20) && !this.props.isBodyshop && this.props.auth.permissions.ChainAssessmentSystem !== AssessmentSystemType.DBS && (
          <Link to={'/EvaluationHistory/' + this.props.order.Id}>
            <Button style='secondary' labelText={translation('15094')} />
          </Link>)}
      </div>
    )
  }

  render () {
    const onHeaderClick = () => {
      let prop = 'AfterEvaluation'
      if (this.props.isBodyshop) prop = 'BodyshopAfterEvaluation'
      this.props.onHeaderClick(prop)
    }
    let title = { icon: '/images/svgs/inspection/assessment.svg', text: '901' }
    return (
      <InspectionItem onHeaderClick={onHeaderClick} title={title} renderContent={this.renderContent} checked={this.props.AfterEvaluation.Checked} />
    )
  }
}

Assessment.defaultProps = {
  isBodyshop: false
}

Assessment.propTypes = {
  isBodyshop: PropTypes.bool,
  AfterEvaluation: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired
}

Assessment.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}
export default connect(mapStateToProps, {
})(Assessment)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/Assessment/index.js